import { render } from "./DeliveryConfirm.vue?vue&type=template&id=3b5bfc8e&scoped=true"
import script from "./DeliveryConfirm.vue?vue&type=script&lang=js"
export * from "./DeliveryConfirm.vue?vue&type=script&lang=js"

import "./DeliveryConfirm.vue?vue&type=style&index=0&id=3b5bfc8e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3b5bfc8e"

export default script